/* eslint-disable react/prop-types */
import React, { FC, useEffect, useRef, useCallback } from 'react'
import { List, ListProps } from 'react-virtualized'
import Scrollbars from 'react-scrollbars-custom'
import styled from 'styled-components'

interface ScrollState {
    scrollTop: number
    scrollLeft: number
}

export const listStyle: React.CSSProperties = {
    overflowX: 'unset',
    overflowY: 'unset'
}

export const VirtualizedList: FC<ListProps> = props => {
    // eslint-disable-next-line prettier/prettier
    const listRef = useRef<List>(null)

    useEffect(() => {
        if (listRef && listRef.current?.Grid) {
            listRef.current.recomputeRowHeights()
        }
    })

    const handleScroll = (scrollValues: ScrollState | React.UIEvent<HTMLDivElement>) => {
        if ('scrollTop' in scrollValues && 'scrollLeft' in scrollValues) {
            const { scrollTop, scrollLeft } = scrollValues

            const grid = listRef.current?.Grid
            grid && grid.handleScrollEvent({ scrollTop, scrollLeft })
        }
    }

    const { width, height, ...rest } = props

    return (
        <Container>
            <Scrollbars
                style={{ height, width }}
                onScroll={handleScroll}
                disableTrackYWidthCompensation
                removeTracksWhenNotUsed
                mobileNative
            >
                <List {...props} autoWidth={true} ref={listRef} style={listStyle} />
            </Scrollbars>
        </Container>
    )
}

const Container = styled.div`
    width: 100%;
    > div {
        width: 100%;
        > div {
            width: 100%;
        }
    }
`

export default React.memo(VirtualizedList)
